module.exports = __webpack_public_path__ + "static/img/FITmenu02.c6ee7e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu02.png
// module id = xqjf
// module chunks = 1